import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Col, Container, Row, Spinner } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { ContactEdition } from './ContactEdition';
import { PasswordEdition } from './PasswordEdition';
import { ProfileDeletionWithGlobalContext } from './ProfileDeletion';
import { ProfileEdition } from './ProfileEdition';
import { ProfileNavWithGlobalContext } from './ProfileNav/ProfileNav';

const Profile: React.SFC<IGlobalContextProps & RouteComponentProps> = ({
  context,
  location,
}) => {
  const { updateUser, user } = context;
  const pathname = location.pathname.replace(`/profile/`, '');

  return user ? (
    <Row style={{ minHeight: 'calc(100% - 145px)' }}>
      <ProfileNavWithGlobalContext pathname={pathname} />
      <Col md='10'>

        {pathname === '' && ( <ProfileEdition user={user} refreshUser={updateUser} />)}

        {pathname === 'password/' && <PasswordEdition user={user} />}
        
        {pathname === 'contact/' && ( <ContactEdition user={user} refreshUser={updateUser} /> )}
        
        {pathname === 'delete/' && <ProfileDeletionWithGlobalContext />}
      </Col>
    </Row>
  ) : (
    <Container
      className='d-flex flex-column justify-content-around align-items-center'
      style={{ minHeight: 'calc(100% - 145px)' }}
    >
      <div className='d-flex flex-column align-items-center'>
        <Spinner type='grow' color='primary' />
        <span className='mt-3'>Chargement...</span>
      </div>
    </Container>
  );
};

export const ProfileWithGlobalContext = withGlobalContext(withRouter(Profile));



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.tsx